import { DefaultActions_create, DefaultActions_terminate, DefaultActions_UpdateArgs$3, DefaultActions_runUpdate, DefaultActions_ChildModel$2, Child$1, ChildAbsentStrategy$1, Child_absentChildCheck } from "../../Common/Terminate.js";
import { update as update_1, init as init_1 } from "../../Visualization/Screenshot/ScreenshotState.js";
import { ScreenshotUpdateArgs, ScreenshotFor, Mode as Mode_1 } from "../../Visualization/Screenshot/ScreenshotTypes.js";
import { OutboundMsg, LocalMsg, ModelCustomStentReport, Mode as Mode_2 } from "./CustomStentReportTypes.js";
import { Cmd_none, Cmd_map, Cmd_batch } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { tryFind, ofArray, singleton } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { some } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { equals } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { InstitutionClinicalDesignation } from "../../RAWMap.Models/View/Institution.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_either } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { securedApi } from "../../Api.js";
import { Toast_errorToast } from "../../Common/General.js";
import { ErrorMessage_get_describe } from "../../RAWMap.Models/ErrorMessage.js";
import { init as init_2, tryTerminate, update as update_2 } from "./ReportPrompt/ReportPromptState.js";
import { S3Context } from "../../Common/AwsCommon.js";
import { FileManagementUpdateArgs } from "../../FileManagement/FileManagementTypes.js";
import { ReportPromptInitArgs, ReportPromptUpdateArgs } from "./ReportPrompt/ReportPromptTypes.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { update as update_3 } from "../../Common/InboundOutbound.js";

export const childAbsentStrategy = new ChildAbsentStrategy$1(0, [(model) => Child_absentChildCheck(model.PromptComponent.child)]);

export function init(args) {
    const patternInput = init_1(new Mode_1(2, []), args.selectedStudy.patientId, args.selectedStudy.studyId);
    return [new ModelCustomStentReport(args.selectedStudy, args.selectedPatient, args.patientInstitution, args.studyAnalysis, undefined, patternInput[0], new Mode_2(0, []), args.devices, args.stentPlanScreenshots, args.compositeScreenshots, args.maybePatientInfo, new DefaultActions_ChildModel$2(new Child$1(1, []), childAbsentStrategy, "report prompt component")), Cmd_batch(ofArray([Cmd_map((Item) => (new LocalMsg(3, [Item])), patternInput[1]), singleton((dispatch) => {
        dispatch(new LocalMsg(1, []));
    })]))];
}

export function updateInbound(_args, _msg, model) {
    return [model, Cmd_none(), Cmd_none()];
}

function setMode(model, mode) {
    return new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, model.MaybePreviousStudy, model.ScreenshotModel, mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, model.PromptComponent);
}

export function updateLocal(args, msg, model) {
    let bind$0040_2;
    let matchResult, ex, studies, e, msg_1, metadata, msg_8, promptType;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            if (msg.fields[0].tag === 1) {
                matchResult = 3;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 2;
                studies = msg.fields[0].fields[0];
            }
            break;
        }
        case 3: {
            if (msg.fields[0].tag === 1) {
                if (msg.fields[0].fields[0].tag === 0) {
                    matchResult = 6;
                }
                else {
                    matchResult = 5;
                }
            }
            else {
                matchResult = 4;
                msg_1 = msg.fields[0].fields[0];
            }
            break;
        }
        case 4: {
            if (msg.fields[0].elmishChainedMsg.tag === 0) {
                matchResult = 9;
                msg_8 = msg.fields[0];
            }
            else if (msg.fields[0].elmishChainedMsg.fields[0].tag === 1) {
                if (msg.fields[0].elmishChainedMsg.fields[0].fields[0] != null) {
                    matchResult = 8;
                    metadata = msg.fields[0].elmishChainedMsg.fields[0].fields[0];
                }
                else {
                    matchResult = 7;
                }
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 5: {
            matchResult = 10;
            break;
        }
        case 6: {
            matchResult = 11;
            promptType = msg.fields[0];
            break;
        }
        default: {
            matchResult = 0;
            ex = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some("CustomReport exception:"), ex);
            return [model, Cmd_none(), Cmd_none()];
        }
        case 1:
            if ((model.SelectedStudy.studyNumber > 0) && equals(model.PatientInstitution.clinicalDesignation, new InstitutionClinicalDesignation(0, []))) {
                return [model, Cmd_OfAsyncWith_either((x) => {
                    Cmd_OfAsync_start(x);
                }, securedApi(args.fileArgs.Token).getPatientStudies, model.SelectedStudy.patientId, (Item) => (new LocalMsg(2, [Item])), (Item_1) => (new LocalMsg(0, [Item_1]))), Cmd_none()];
            }
            else {
                return [new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, undefined, model.ScreenshotModel, model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, model.PromptComponent), Cmd_none(), Cmd_none()];
            }
        case 2:
            return [new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, tryFind((study) => (study.studyNumber === (model.SelectedStudy.studyNumber - 1)), studies), model.ScreenshotModel, model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, model.PromptComponent), Cmd_none(), Cmd_none()];
        case 3:
            return [model, Toast_errorToast(ErrorMessage_get_describe()(e)), Cmd_none()];
        case 4: {
            const patternInput = update_1(new ScreenshotUpdateArgs(args.fileArgs.Token, args.fileArgs.Context, new ScreenshotFor(0, [0])), msg_1, model.ScreenshotModel);
            return [new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, model.MaybePreviousStudy, patternInput[0], model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, model.PromptComponent), Cmd_map((Item_2) => (new LocalMsg(3, [Item_2])), patternInput[1]), Cmd_none()];
        }
        case 5:
            return [model, Cmd_none(), Cmd_none()];
        case 6:
            return [model, Cmd_none(), Cmd_none()];
        case 7:
            return [model, Cmd_batch(singleton(singleton((dispatch) => {
                dispatch(new LocalMsg(5, []));
            }))), Cmd_none()];
        case 8:
            return [model, singleton((dispatch_1) => {
                dispatch_1(new LocalMsg(5, []));
            }), singleton((dispatch_2) => {
                dispatch_2(new OutboundMsg(0, [metadata]));
            })];
        case 9: {
            const patternInput_1 = DefaultActions_runUpdate(new DefaultActions_UpdateArgs$3((msg_9, promptModel) => {
                let bind$0040, bind$0040_1;
                if (msg_9.tag === 1) {
                    return [promptModel, Cmd_none()];
                }
                else {
                    return update_2(new ReportPromptUpdateArgs((bind$0040 = args.fileArgs, new FileManagementUpdateArgs(bind$0040.Token, bind$0040.Credentials, (bind$0040_1 = args.fileArgs.Context, new S3Context(bind$0040_1.S3Config, bind$0040_1.S3Client, bind$0040_1.S3Expiry, args.fileArgs.Context.ActiveBucket)))), args.userRoles), msg_9.fields[0], promptModel);
                }
            }, model), model.PromptComponent, msg_8);
            return [new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, model.MaybePreviousStudy, model.ScreenshotModel, model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, patternInput_1[0]), Cmd_map((Item_4) => (new LocalMsg(4, [Item_4])), patternInput_1[1]), Cmd_none()];
        }
        case 10: {
            const patternInput_2 = DefaultActions_terminate(tryTerminate, model.PromptComponent);
            return [new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, model.MaybePreviousStudy, model.ScreenshotModel, model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, patternInput_2[0]), Cmd_map((Item_5) => (new LocalMsg(4, [Item_5])), patternInput_2[1]), Cmd_none()];
        }
        default: {
            const createPromptComponent = (model_2) => {
                const createdPrompt = init_2(new ReportPromptInitArgs(model_2.SelectedStudy, model_2.SelectedPatient, model_2.PatientInstitution, model_2.StudyAnalysis, model_2.MaybePreviousStudy, args.userRoles, promptType, model_2.Devices, model_2.StentPlanScreenshots, model_2.CompositeScreenshots, model_2.MaybePatientInfo));
                const patternInput_3 = DefaultActions_create(createdPrompt[0], createdPrompt[1], model_2.PromptComponent);
                return [new ModelCustomStentReport(model_2.SelectedStudy, model_2.SelectedPatient, model_2.PatientInstitution, model_2.StudyAnalysis, model_2.MaybePreviousStudy, model_2.ScreenshotModel, model_2.Mode, model_2.Devices, model_2.StentPlanScreenshots, model_2.CompositeScreenshots, model_2.MaybePatientInfo, patternInput_3[0]), Cmd_batch(singleton(Cmd_map((Item_6) => (new LocalMsg(4, [Item_6])), patternInput_3[1]))), Cmd_none()];
            };
            const matchValue_1 = model.PromptComponent.child;
            switch (matchValue_1.tag) {
                case 1:
                case 2:
                    return createPromptComponent(model);
                default: {
                    const termination = tryTerminate(matchValue_1.fields[0]);
                    if (termination.tag === 1) {
                        return [model, Toast_errorToast(toText(printf("%s was unable to switch."))(model.PromptComponent.childComponentName)), Cmd_none()];
                    }
                    else {
                        termination.fields[0]();
                        return createPromptComponent(new ModelCustomStentReport(model.SelectedStudy, model.SelectedPatient, model.PatientInstitution, model.StudyAnalysis, model.MaybePreviousStudy, model.ScreenshotModel, model.Mode, model.Devices, model.StentPlanScreenshots, model.CompositeScreenshots, model.MaybePatientInfo, (bind$0040_2 = model.PromptComponent, new DefaultActions_ChildModel$2(new Child$1(2, []), bind$0040_2.childAbsentStrategy, bind$0040_2.childComponentName))));
                    }
                }
            }
        }
    }
}

export function update(args, msg, model) {
    return update_3(updateLocal, updateInbound, args, msg, model);
}

